import { gql } from '@common/hooks';

export const BillingStatsItemFragment = gql`
  fragment BillingStatsItemFragment on WorksBillingStats {
    title
    subtitle
    counts {
      label
      value
    }
    emptyMessage
    footer {
      label
      value
    }
  }
`;

export type BillingStatsItemFragmentType = {
  title: string;
  subtitle: string | undefined;
  counts: {
    label: string;
    value: string;
  }[];
  emptyMessage: string;
  footer?: {
    label: string;
    value: string;
  };
};
